import { takeEvery, call, put, all } from "redux-saga/effects";
import { actionTypes, actions } from "./actions";
import { actions as commonActions } from "../../../store/actions";
import { customerDeletionAPI, getRollbackIngestionAPI, getRollbackIngestionDetailsAPI, getRollbackPartnersAPI, resetAccountBalanceAPI, rollbackAPI } from "./endpoints";

function* getEzdsSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(getRollbackPartnersAPI, { isEnabled: 1, PartnerType: 'EZD' });
    yield put(actions.setEzds(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* getMcdsSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(getRollbackPartnersAPI, { isEnabled: 1, PartnerType: 'MCD' });
    yield put(actions.setMcds(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* getEzdRollbackIngestionsSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(getRollbackIngestionAPI, action.payload);
    yield put(actions.setEzdRollbackIngestions(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* getMcdRollbackIngestionsSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(getRollbackIngestionAPI, action.payload);
    yield put(actions.setMcdRollbackIngestions(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* getIngestionDetailsSaga(action) {
  try {
    yield put(actions.rollbackLoader(true));
    const _api = yield call(getRollbackIngestionDetailsAPI, action.payload);
    yield put(actions.setIngestionDetails(_api.data.results));
    yield put(actions.rollbackLoader(false));
  } catch (error) {
    yield put(actions.rollbackLoader(false));
    console.log(error);
  }
}

function* getRollbackIngestionSaga(action) {
  try {
    yield put(actions.rollbackLoader(true));
    const _api = yield call(rollbackAPI, action.payload);
    yield put(actions.rollbackLoader(false));
    yield put(actions.rollbackPopupOpen(false));
    if (_api?.data?.success) {
      yield put(
        commonActions.setAlert({
          message: "Rollback is completed",
          alertType: "success",
          showToast: true,
        })
      );
    }
  } catch (error) {
    yield put(
      commonActions.setAlert({
        message: error?.response?.data?.message || "Rollback is failed",
        alertType: "error",
        showToast: true,
      })
    );
    yield put(actions.rollbackLoader(false));
    console.log(error);
  }
}

function* getResetAccountBalanceSaga(action) {
  try {
    yield put(actions.rollbackLoader(true));
    const _api = yield call(resetAccountBalanceAPI, action.payload);
    if (_api?.data?.success) {
      yield put(
        commonActions.setAlert({
          message: "Reset account balance is completed",
          alertType: "success",
          showToast: true,
        })
      );
    }
    yield put(actions.rollbackLoader(false));
    yield put(actions.rollbackPopupOpen(false));
  } catch (error) {
    yield put(
      commonActions.setAlert({
        message: error?.response?.data?.message || "Reset account balance is failed",
        alertType: "error",
        showToast: true,
      })
    );
    yield put(actions.rollbackLoader(false));
    console.log(error);
  }
}

function* getCustomerDeletionSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(customerDeletionAPI, action.payload);
    if (_api?.data?.success) {
      yield put(
        commonActions.setAlert({
          message: "Customer deletion is completed",
          alertType: "success",
          showToast: true,
        })
      );
    }
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(
      commonActions.setAlert({
        message: error?.response?.data?.message || "Customer deletion is failed",
        alertType: "error",
        showToast: true,
      })
    );
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

export function* withRollbackIngestionSaga() {
  yield all([
    takeEvery(actionTypes.GET_EZDS, getEzdsSaga),
    takeEvery(actionTypes.GET_MCDS, getMcdsSaga),
    takeEvery(actionTypes.GET_EZD_ROLLBACK_INGESTIONS, getEzdRollbackIngestionsSaga),
    takeEvery(actionTypes.GET_MCD_ROLLBACK_INGESTIONS, getMcdRollbackIngestionsSaga),
    takeEvery(actionTypes.GET_INGESTION_DETAILS, getIngestionDetailsSaga),
    takeEvery(actionTypes.ROLLBACK_INGESTION, getRollbackIngestionSaga),
    takeEvery(actionTypes.RESET_ACCOUNT_BALANCE, getResetAccountBalanceSaga),
    takeEvery(actionTypes.CUSTOMER_DELETION, getCustomerDeletionSaga),
  ]);
}
